import { GENERATOR_NAMES } from 'common/components/CopyMagic/constants';
import * as COURSE_OUTLINE_TRACKING_HOOKS from 'common/components/CopyMagic/generators/CourseOutline/hooks/trackingCallbacks';
import * as CONVERSATION_ASSISTANT_TRACKING_HOOKS from 'common/components/CopyMagic/generators/ConversationAssistant/hooks/trackingCallbacks';
import * as TRACKING_HOOKS from 'common/components/CopyMagic/hooks/trackingCallbacks';

export const GENERATOR_TRACKING_HOOKS = {
  [GENERATOR_NAMES.COURSE_OUTLINE]: COURSE_OUTLINE_TRACKING_HOOKS,
  [GENERATOR_NAMES.CONTENT_ASSISTANT]: TRACKING_HOOKS,
  [GENERATOR_NAMES.HEADLINE_ASSISTANT]: TRACKING_HOOKS,
  [GENERATOR_NAMES.CONVERSATION_ASSISTANT]: {
    ...TRACKING_HOOKS,
    ...CONVERSATION_ASSISTANT_TRACKING_HOOKS,
  },
} as const;
